import css from 'styled-jsx/css';

const styles = css.global`#rastreadores-o-que-e {
  position: relative;
  display: flex;
  flex-direction: column;
  /* gap: 26px; */
}

.o-que-e-1 {
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: #cc0000;
  color: #fff;
}

.image-1,
.image-2 {
  width: 100%;
  height: 232px;
  object-fit: cover;
}

.o-que-e-1 .texts-div-1 {
  display: flex;
  flex-direction: column;
  padding: 0 27px;
  gap: 15px;
  padding-top: 15px;
  padding-bottom: 25px;
  max-width: 286px;
}

.o-que-e-1 .title {
  font-family: 'SantanderHeadline';
  font-size: 24px;
  font-weight: 400;
  line-height: 36px;
  letter-spacing: 0px;
  margin-bottom: 10px;
}

.o-que-e-1 .text {
  font-family: SantanderText;
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0px;
}

.text-small {
  font-family: SantanderText;
  font-size: 14px;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0px;
}

.o-que-e-2 {
  background-color: #990000;
  color: #fff;
}

.o-que-e-2 .texts-div-2 {
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  max-width: 260px;
  padding-top: 17px;
  padding-bottom: 39px;
  gap: 50px;
}

.o-que-e-2 .title {
  font-family: 'SantanderHeadline';
  font-size: 20px;
  font-weight: 900;
  line-height: 29px;
  letter-spacing: 0em;
  text-align: center;
}

.o-que-e-2 .list {
  display: flex;
  flex-direction: column;
  display: flex;
  align-items: flex-start;
  gap: 34px;

  font-family: SantanderText;
  font-size: 16px;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: left;
}

.o-que-e-2 .list b {
  font-family: SantanderText;
  font-size: 16px;
  font-weight: 600 !important;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: left;
}

.o-que-e-2 .list-item {
  display: flex;
  gap: 20px;
}

.o-que-e-2 .img-div {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 2px solid #fff;
  border-radius: 50%;
  height: 47px;
  width: 47px;
  padding: 5px;
}

.o-que-e-2 .list-img {
  height: 30px;
  width: 30px;
}

.bolinhas-red,
.bolinhas-white {
  position: absolute;
  background-repeat: no-repeat;
}

.bolinhas-red {
  top: 824px;
  z-index: -1;
  background-image: url(assets/rastreadores/bolinhas-red-mb.png);
  width: 145px;
  height: 61px;
}

.bolinhas-white {
  top: 615px;
  right: 0;
  z-index: 1;
  background-image: url(assets/rastreadores/bolinhas-white-mb.png);
  width: 46px;
  height: 215px;
}

.break-line {
  display: block;
}

@media (min-width: 992px) {
  #rastreadores-o-que-e {
    gap: 0;
  }

  .image-1,
  .image-2 {
    position: absolute;
  }

  .o-que-e-1 {
    position: relative;
    width: 100%;
    height: 463px;
    background-image: linear-gradient(90deg, #fff 35%, #cc0000 35%);
    z-index: 1;
    justify-content: center;
  }

  .o-que-e-1 .ctn {
    display: flex;
    justify-content: flex-end;
  }

  .o-que-e-1 .texts-div-1 {
    max-width: 560px;
    width: 100%;
    margin: 0;
    padding: 0;
    /* padding-top: 32px; */
  }

  .o-que-e-1 .image-1 {
    width: 41%;
    height: 434px;
    top: -45px;
  }

  .o-que-e-1 .title {
    font-size: 32px;
    font-weight: 400;
    line-height: 48px;
    letter-spacing: 0px;
    margin-bottom: 16px;
  }

  .o-que-e-2 {
    position: relative;
    z-index: 3;
    height: 570px;
  }

  .o-que-e-2 .ctn {
    display: flex;
    justify-content: flex-start;
  }

  .o-que-e-2 .image-2 {
    width: 41%;
    height: 546px;
    top: 0px;
    right: 0;
    border-radius: 4px;
  }

  .o-que-e-2 .texts-div-2 {
    max-width: 510px;
    width: 100%;
    margin: 0;
    padding-top: 70px;
    gap: 60px;
  }

  .o-que-e-2 .title {
    font-weight: 900;
    font-size: 32px;
    line-height: 46px;
  }

  .o-que-e-2 .list {
    font-size: 20px;
    line-height: 28px;
    gap: 69px;
  }

  .o-que-e-2 .list b {
    font-size: 20px;
    line-height: 28px;
  }

  .o-que-e-2 .list-item {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .o-que-e-2 .img-div {
    height: 70px;
    width: 70px;
    padding: 10px;
  }

  .o-que-e-2 .list-img {
    height: 46px;
    width: 46px;
  }

  .bolinhas-red {
    z-index: 2;
    top: 395px;
    width: 269px;
    height: 99px;
    background-image: url(assets/rastreadores/bolinhas-red-ds.png);
  }

  .bolinhas-white {
    /* z-index: 2;
    top: 100px;
    width: 130px;
    height: 357px;
    right: 5px;
    background-image: url(assets/rastreadores/bolinhas-white-ds.png); */
    display: none;
  }

  .break-line {
    display: none;
  }
}

@media (min-width: 1200px) {
  .o-que-e-1 {
    background-image: linear-gradient(90deg, #fff 40%, #cc0000 40%);
  }

  .o-que-e-1 .image-1 {
    width: 47%;
  }

  .o-que-e-2 .image-2 {
    width: 50%;
  }

  .bolinhas-white {
    display: block;
    z-index: 2;
    top: 100px;
    width: 40px;
    height: 357px;
    right: 5px;
    background-image: url(assets/rastreadores/bolinhas-white-ds.png);
  }
}

@media (min-width: 1400px) {
  .o-que-e-1 {
    background-image: linear-gradient(90deg, #fff 40%, #cc0000 40%);
  }

  .o-que-e-1 .image-1 {
    width: 49%;
  }

  .o-que-e-2 .image-2 {
    width: 53%;
  }

  .bolinhas-white {
    width: 100px;
  }
}

@media (min-width: 1500px) {
  .bolinhas-white {
    width: 130px;
  }
}
`;

export default styles;